var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-inner"},[_c('div',{staticClass:"wly-body-wrapper"},[_c('div',{staticClass:"wly-body-inner",style:({ padding: _vm.computeIsExtranet })},[(!_vm.isInternational)?_c('Header'):_c('GlobalHeader'),_c('div',{staticClass:"wly-main-container"},[_c('Content')],1)],1)]),(_vm.computeBlackFooterVisible)?_c('BlackFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }